import { AvatarUserComponent } from './avatar-user.component';

export default angular
  .module('sfMobile.components.avatar-user', [
    'sfMobile.constants.image-sizes',
    'sfMobile.services.files',
    'sfMobile.components.avatar',
  ])
  .component('sfAvatarUser', AvatarUserComponent).name;
